
export default function Footer() {
  return (
    <footer className="bg-[#0B2A4A] text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo y descripción */}
          <div className="md:col-span-2">
            <div className="mb-4">
              <img
                src="https://centrourologicoguadalajara.com/logo.png"
                alt="UroMás - Centro Urológico de Guadalajara"
                className="h-14 w-auto"
                loading="lazy"
              />
            </div>
            <p className="text-blue-100 mb-4 max-w-md">
              UroMás Centro Urológico de Guadalajara - El centro urológico líder en Guadalajara, Jalisco. 
              Urólogos certificados con tecnología de vanguardia para tu salud urológica.
            </p>
            {/* Redes sociales removidas a solicitud */}
          </div>

          {/* Servicios */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Servicios del Centro Urológico</h4>
            <ul className="space-y-2 text-blue-100">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Cirugía Láser de Próstata</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Cálculos Urinarios</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Disfunción Eréctil</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Circuncisión Láser</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Verrugas Genitales</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Engrosamiento de Pene</a></li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Centro Urológico</h4>
            <div className="space-y-3 text-blue-100">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-[#1B84FF] mr-2 mt-1"></i>
                <div>
                  <p className="text-sm font-medium">Av. de las Américas 932, Ayuntamiento</p>
                  <p className="text-sm">44620 Guadalajara, Jal.</p>
                </div>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-[#1B84FF] mr-2"></i>
                <span className="text-sm">+52 33 1864 8274</span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-[#1B84FF] mr-2"></i>
                <span className="text-sm">+52 33 1864 8274</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-[#1B84FF] mr-2"></i>
                <span className="text-sm">info@centrourologicoguadalajara.com</span>
              </div>
              <div className="flex items-center">
                <i className="ri-time-line text-[#1B84FF] mr-2"></i>
                <span className="text-sm">Lun-Vie: 8:00-18:00</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-blue-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-blue-200 text-sm">
            © 2024 UroMás Centro Urológico de Guadalajara. Todos los derechos reservados.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <a href="#" className="text-blue-200 hover:text-white text-sm transition-colors cursor-pointer">
              Aviso de Privacidad
            </a>
            <span className="text-blue-300">|</span>
            <a href="https://citadoctor.com.mx" className="text-blue-200 hover:text-white text-sm transition-colors cursor-pointer">
              sitio web realizado por CitaDoctor.com.mx
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
